export type Area =
    | "All"
    | "AsistenciaEspiritual"
    | "Enseñanza"
    | "Musica"
    | "Juventud"
    | "Comunicacion"
    | "Capacitación";

export const areaValues: Area[] = [
    "All",
    "AsistenciaEspiritual",
    "Enseñanza",
    "Musica",
    "Juventud",
    "Comunicacion",
    "Capacitación",
];

export const areaLabels: Record<Area, string> = {
    All: "Todas",
    AsistenciaEspiritual: "Asistencia Espiritual",
    Enseñanza: "Enseñanza",
    Musica: "Música",
    Juventud: "Juventud",
    Comunicacion: "Comunicación",
    Capacitación: "Capacitación",
};

export const areaOptions = areaValues.map(value => ({
    value,
    label: areaLabels[value],
}));
